var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 56,
    viewBox: "0 0 66 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: #ffc552;\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .cls-2 {\r\n        opacity: 0.3;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Color_Fill_1",
    "data-name": "Color Fill 1",
    className: "cls-1",
    d: "M7,53s0.292-6.06,3-18c0,0,2.559-11.705,2-17a3.375,3.375,0,0,1,3-4l14-4,8-8s3.239-3.309,6,0L61,21s1.306,1.5-1,4l-7,7L48,45a6.1,6.1,0,0,1-6,4s-7.885.358-12,2L11,54S7.087,55.268,7,53Zm5-8s5.551-21.437,4-26l16-5L48,30,43,44s-20.909,2.573-27,6L28,38s5.544,1.769,8-2a5.712,5.712,0,0,0,1-7s-0.7-4.247-7-5c0,0-7.091.105-7,6,0,0,.064,3.986,2,4ZM28,33s-1.427-2.412,0-4a3.5,3.5,0,0,1,5,0s1.6,2.2,0,4C33,33,29.882,35.374,28,33Zm7-22,5-5L56,22l-5,5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Color_Fill_2",
    "data-name": "Color Fill 2",
    className: "cls-2",
    d: "M10,47l6-30,17-4L49,29,44,46,16,51l-3-3L26,36l8-1,1-4-1-4-5-1-3,3v4l-4,5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.47cb6b39330edef3dd2d70dbcb24efd7.svg";
export { ForwardRef as ReactComponent };